import { apiPollingTimebasedStopCheck } from "../../../hooks/useApi/useApi";

import type { ApiPollingStopConditionType } from "../../../hooks/useApi/useApi";

export default function getBankIdPollingStopCondition<TResult, TError, TParameters>(
	isPending: (res: TResult) => boolean,
): "defaultTimeBasedCondition" | ApiPollingStopConditionType<TResult, TError, TParameters> {
	return context =>
		apiPollingTimebasedStopCheck()(context) ||
		context.error !== null ||
		(context.data !== null && !isPending(context.data));
}
